import PropTypes from 'prop-types';
import React from 'react';
import {Modal, ModalOverlay, useDisclosure} from '@chakra-ui/react';

export default function ModalButton({renderButton, children, ...props}) {
  const {isOpen, onOpen, onClose} = useDisclosure();
  return (
    <>
      {renderButton(onOpen)}
      <Modal isOpen={isOpen} onClose={onClose} {...props}>
        <ModalOverlay />
        {children(onClose)}
      </Modal>
    </>
  );
}

ModalButton.propTypes = {
  children: PropTypes.func.isRequired,
  renderButton: PropTypes.func.isRequired
};
